module.exports = {
  assist: {
    "light-blue": "#EEF1FD",
    "light-pink": "#FAE5F6",
    "light-peach": "#FFF0EB",
    blue: "#93A6D6",
    pink: "#FF83E6",
    peach: "#FFB197",
  },
  aqua: {
    100: "#E6F9FA",
    200: "#CFF4F5",
    DEFAULT: "#01BDC5",
  },
  butterscotch: {
    100: "#FFF7EA",
    lighter: "#FFFADD",
    200: "#FEE9C3",
    dark: "#DC8E04",
    DEFAULT: "#FBAE26",
  },
  charcoal: {
    100: "#EFF0F7",
    200: "#DDDDEA",
    lighter: "#888AC9",
    700: "#70729B",
    light: "#52549A",
    dark: "#162250",
    DEFAULT: "#333570",
  },
  cornflower: {
    lighter: "#ACAEDF",
    dark: "#484E8E",
    DEFAULT: "#5E66AC",
  },
  current: "currentColor",
  emerald: {
    100: "#E9F3F1",
    200: "#D5E8E4",
    DEFAULT: "#1F826A",
  },
  focused: "#D7DDF3",
  grey: {
    light: "#EBEBF1",
    lighter: "#F5F5F8",
    lightest: "#FCFCFD",
  },
  gray: {
    pale: "#F8F8F9",
    "blue-pale": "#F2F5FE",
  },
  "legacy-green": {
    DEFAULT: "#4A7641",
  },
  "legacy-red": {
    100: "#F9ECEB",
    DEFAULT: "#C7493D",
  },
  lime: {
    100: "#F8FFE9",
    200: "#E3F3DD",
    DEFAULT: "#1F826A",
  },
  magenta: {
    100: "#F8E6F2",
    200: "#F2CFE6",
    500: "#E10087",
    DEFAULT: "#B50575",
  },
  manatee: {
    diet: "#BEBED1",
    DEFAULT: "#8485A8",
    polar: "#DEDEE7",
  },
  obsidian: "#080812",
  orange: {
    50: "#FFF8F4",
    100: "#FEF4ED",
    200: "#FDDAC6",
    DEFAULT: "#FB7326",
  },
  royal: {
    50: "#F1F5FF",
    100: "#E6EBFD",
    200: "#CFD9FB",
    400: "#99AEF5",
    500: "#491CFF",
    dark: "#0029B2",
    DEFAULT: "#0034E5",
  },
  rose: {
    light: "#FDC3D1",
  },
  snowflake: {
    muddy: "#EFEFF4",
    DEFAULT: "#F9F9FB",
  },
  transparent: "transparent",
  warning: {
    100: "#FDEFED",
    200: "#F7D0CC",
    DEFAULT: "#DD3822",
  },
  white: "white",
  // The following colours only to be used for rostering
  shiftwarning: {
    DEFAULT: "#FA7E61",
    200: "#FFEAE0",
  },
  scheduled: {
    DEFAULT: "#D7F3F5",
    border: "#88DFE4",
  },
  inprogress: {
    DEFAULT: "#E6EBFC",
    border: "#0034E5",
  },
  complete: {
    DEFAULT: "#E3F3DD",
    border: "#99C6B5",
  },
  cancelled: {
    DEFAULT: "#FFF6D7",
    border: "#FCD691",
  },
  vacant: {
    DEFAULT: "#EFD2CF",
    border: "#EB9C92",
  },
  inherit: "inherit",
};
